import { useState } from 'react';
import { CollapsibleStyled } from './styled';
import BoldText from '../BoldText';
import { ChevronDownIcon, ChevronUpIcon } from '@shopify/polaris-icons';
import { Icon, Collapsible as CollapsiblePolaris, Card } from '@shopify/polaris';
import { ICollapsible } from '@/types';
import Required from '@/components/Required';

export const Collapsible = ({ defaultOpen = true, padding, contentRight, ...props }: ICollapsible) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <CollapsibleStyled>
      <Card padding={padding}>
        <div className="title-container" onClick={() => setOpen(!open)}>
          <div className="d-flex justify-between w-full">
            <BoldText className="w-fit">
              {props.title} {props.required ? <Required /> : null}
            </BoldText>
            {contentRight ? contentRight : null}
          </div>
          <Icon source={open ? ChevronDownIcon : ChevronUpIcon} tone="base" />
        </div>
        <CollapsiblePolaris
          open={open}
          id="basic-collapsible"
          transition={{ duration: '500ms', timingFunction: 'ease-in-out' }}
          expandOnPrint
        >
          {props.children}
        </CollapsiblePolaris>
      </Card>
    </CollapsibleStyled>
  );
};
